import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import UsersFilterForm from '../components/UsersFilterForm';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components'
import { requestUserActivityAudits, requestUsersTypeahead } from "../../../store/users/UsersActions";
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import Moment from '../../../components/utils/Moment';
import { hostTitle } from '../../../config/ui';

class UserAuditLog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: '',
      filtered: [],
      selectedOption: 0,
      from: null,
      to: null,
      email: ''
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.changeFilters = this.changeFilters.bind(this);
  }

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.fetchData(this.state));

  fetchData = () => {
    const offset = this.state.page * this.state.pageSize;
    const limit = this.state.pageSize;
    const filters = this.state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getUserActivityAudits({
        offset: offset,
        limit: limit,
        search: search,
        filters: filters,
        email: this.state.email,
        from: this.state.from,
        to: this.state.to
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 10,
        order: '',
        search,
        filters,
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            const email = item.email ? `(${item.email})` : '';
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName} ${email}`,
            });
          });
        }
        return options;
      });
  };

  changeFilters(params) {
    let email = (params.provider !== undefined) ? params.provider.name : '';
    this.setState({
      email: email.substring(
        email.lastIndexOf('(') + 1,
        email.length - 1,
      ),
      from: params.from,
      to: params.to
    }, () => this.fetchData(this.state));

  }

  render() {
    const { users } = this.props;
    return (
      <div id="content">
        <Helmet title={`User Audit Log – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Administration', 'User Audit Log']}
              icon="fa fa-fw fa-users"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={users.audits.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>User Audit Log</h2>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <div className="row" >
                      <div className="col-md-1">
                      </div>
                      <div className="col-md-1" style={{ padding: 5 }}>
                        <strong> User Filter </strong>
                      </div>
                      <div className="col-md-3" >
                        <UsersFilterForm searchUsers={this.searchUsers} isMulti={false} onSubmit={this.changeFilters} />
                      </div>
                    </div>
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.users.isAuditLoading}
                      data={this.props.users.audits ? this.props.users.audits.list : []}
                      onFetchData={this.fetchData}
                      defaultSorted={[
                        {
                          id: 'createdAt',
                          desc: true,
                        },
                      ]}
                      columns={[
                        {
                          Header: 'Id',
                          id: 'id',
                          accessor: 'id',
                          show: false,
                        },
                        {
                          Header: 'Date and Time',
                          accessor: 'createdAt',
                          Cell: (row) => (
                            <Moment
                              date={row.original.createdAt}
                              format="MM/DD/YYYY HH:mm"
                            />
                          ),
                        },
                        {
                          Header: 'Username',
                          accessor: 'username',
                        },
                        {
                          Header: 'Action',
                          accessor: 'action',
                        },
                        {
                          Header: 'AuditedFields',
                          accessor: 'auditedFields',
                        },
                        {
                          Header: 'PatientID',
                          accessor: 'masterPatientID',
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      sortable={false}
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  state => ({
    users: state.users,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  dispatch => ({
    getUserActivityAudits: (params) => dispatch(requestUserActivityAudits(params)),
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
  }),
)(UserAuditLog);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/UserAuditLog.js